import React, {useEffect, useRef, useState} from "react";
import CatalogItem from "../CatalogItem";
import {columns, dataFields} from "./config";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {getListSuppliesGroupAPI} from "redux/reducer/medicalSupplies";
import ModalCustom from "components/common/ModalCustom/ModalCustom";
import ModalContent from "../ModalContent";
import {Spin, message} from "antd";
import {medicalSuppliesService} from "api";
import Notification from "components/common/notification/notification";

const NhomVTYT = () => {
  const CATALOG_NAME = "Nhóm VTYT";
  const TYPE_FORM = {
    THEM: "Thêm",
    SUA: "Sửa",
  };
  const modalRef = useRef<any>();
  const dispatch = useAppDispatch();
  const medicalSuppliesStore = useAppSelector(
    state => state.medicalSuppliesReducer
  );

  const [typeForm, setTypeForm] = useState("");
  const [catalogData, setCatalogData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(getListSuppliesGroupAPI());
  }, []);

  const handleModalCreat = () => {
    setTypeForm(TYPE_FORM.THEM);
    setCatalogData(null);
    modalRef.current?.openModal();
  };
  const handleModalEdit = recod => {
    setTypeForm(TYPE_FORM.SUA);
    setCatalogData(recod);
    modalRef.current?.openModal();
  };
  const handleRemove = async id => {
    setLoading(true);
    try {
      await medicalSuppliesService.deleteSuppliesGroup(id);
      await dispatch(getListSuppliesGroupAPI());
      setLoading(false);
      Notification("success", `Xóa ${CATALOG_NAME} thành công`);
    } catch (error) {
      setLoading(false);
      Notification(
        "error",
        error?.response?.data ?? `Đã có lỗi khi xóa thông tin ${CATALOG_NAME}`
      );
    }
  };
  const handleSubmitForm = async value => {
    setLoading(true);
    try {
      if (typeForm === TYPE_FORM.THEM) {
        await medicalSuppliesService.postSuppliesGroup(value);
      }
      if (typeForm === TYPE_FORM.SUA) {
        await medicalSuppliesService.putSuppliesGroup(value);
      }
      await dispatch(getListSuppliesGroupAPI());
      setLoading(false);
      Notification("success", `${typeForm} ${CATALOG_NAME} thành công`);
      modalRef.current?.closeModal();
      setCatalogData(null);
    } catch (error) {
      setLoading(false);
      modalRef.current?.closeModal();
      Notification(
        "error",
        error?.response?.data ??
          `Đã có lỗi khi ${typeForm} thông tin ${CATALOG_NAME}`
      );
    }
  };
  return (
    <>
      <Spin spinning={loading}>
        <CatalogItem
          nameCatalog={`Danh mục ${CATALOG_NAME}`}
          tableData={{
            columns,
            dataSource: medicalSuppliesStore.suppliesGroupList,
            pagination: false,
          }}
          isBtnEdit={true}
          onClickCreate={handleModalCreat}
          onClickEdit={data => handleModalEdit(data)}
          onClickRemove={id => handleRemove(id)}
        ></CatalogItem>
      </Spin>
      <ModalCustom
        ref={modalRef}
        width={1000}
        title={`${typeForm} ${CATALOG_NAME}`}
      >
        <ModalContent
          nameCatalog={CATALOG_NAME}
          data={catalogData}
          type={typeForm}
          dataFields={dataFields}
          onSubmitForm={handleSubmitForm}
        ></ModalContent>
      </ModalCustom>
    </>
  );
};

export default NhomVTYT;
